var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"color":"success","loading":_vm.loading},on:{"click":_vm.download}},'v-btn',_vm.$attrs,false),[_c('v-icon',{staticClass:"pr-1"},[_vm._v("fas fa-file-excel")]),_vm._v(" Скачать")],1)}
var staticRenderFns = []

export { render, staticRenderFns }